import { Link, useNavigate } from "react-router-dom";
import { BrandExtraction } from "../components/brand/BrandExtraction";
import { NonWorkspacePage } from "../components/layout/NonWorkspacePage";
import { OperatorSurface } from "../components/ui/OperatorSurface";

export function BrandCreate() {
  const navigate = useNavigate();
  return (
    <NonWorkspacePage width="narrow" header={{
      eyebrow: "Account",
      title: "Create a brand",
      description: "Add the identity the agent should use for this brand.",
      breadcrumbs: [{ label: "Workspace", href: "/home" }, { label: "Brands", href: "/brands" }, { label: "Create" }],
    }}>
      <OperatorSurface>
        <BrandExtraction onComplete={(brandId, brandName) => navigate(`/brand/${encodeURIComponent(brandId)}/settings/profile`, { state: { createdBrandName: brandName } })} />
      </OperatorSurface>
      <Link className="text-sm font-medium text-brand-700 hover:text-brand-800" to="/brands">← Back to brands</Link>
    </NonWorkspacePage>
  );
}
